/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'home': {
    width: 30,
    height: 30,
    viewBox: '0 0 30 30',
    data: '<path pid="0" d="M5 12.4V25h7.143v-5.6c0-1.546 1.279-2.8 2.857-2.8 1.578 0 2.857 1.254 2.857 2.8V25H25V12.4L15 4 5 12.4z" _fill="#fff"/>'
  }
})
